module.exports = __webpack_public_path__ + "assets/5a04ee9c4e24a75e00a2b3d410cefd10.png";